module.exports = __webpack_public_path__ + "img/Battery Icon.925eb056.png";